const hardcodedItineraryInfo = {
  refundableFareUpgrade: false,
  refundableFareUpgradePrice: undefined,
  refundableFareUpgradeShown: false,
  externalSelectionRequest: undefined
};
export const createItinerarySelectionIntegration = ({
  AB,
  trigger,
  setSessionStorageKey
}) => {
  let bookedItinerary;
  const setRequiredDataInSessionStorage = info => {
    Object.entries(info).forEach(([key, value]) => {
      setSessionStorageKey(key, value);
    });
  };
  const setCreateShoppingCartData = data => trigger('frontend-shell:setCreateShoppingCartData', {
    data,
    typeOfCart: 'preShoppingCart'
  });
  const goToNextPage = data => {
    const flightSelectionData = {
      data: {
        ...data,
        ...hardcodedItineraryInfo
      },
      flightNumbers: data.flightNumbers
    };
    if (AB.isFecoCheckoutPassengers) {
      trigger('frontend-shell:showWaitingBetweenSearchAndPax', flightSelectionData);
    } else {
      trigger('frontend-shell:bookFlight', flightSelectionData);
    }
  };
  const selectItinerary = ({
    info,
    request
  }) => {
    bookedItinerary = request;
    setRequiredDataInSessionStorage(info);
    setCreateShoppingCartData(request);
  };
  const continueToPassengers = () => goToNextPage(bookedItinerary);
  const selectItineraryAndContinueToPassengers = ({
    info,
    request
  }) => {
    setRequiredDataInSessionStorage(info);
    goToNextPage(request);
  };
  const continueWithHotel = () => goToNextPage({
    ...bookedItinerary,
    upsellTouchpointClicked: true
  });
  const recoverSearchRequest = searchRequest => trigger('frontend-shell:change-search-request', searchRequest);
  const prepareShoppingCart = ({
    request
  }) => trigger('frontend-shell:precreateShoppingCart', {
    data: request,
    typeOfCart: 'preShoppingCart'
  });
  return {
    selectItinerary,
    continueToPassengers,
    continueWithHotel,
    selectItineraryAndContinueToPassengers,
    recoverSearchRequest,
    prepareShoppingCart
  };
};